import React, { useEffect, useState } from "react";
import classes from "./Login.module.css";
import { Link, useNavigate } from "react-router-dom";
import toast from "components/shared/toast/toast";
import { emailRegex } from "utils/regex";
import { FORGOT_PASSWORD, LOGIN, LOGIN_NEW } from "services/apiEndpoints";
import publicRequest from "services/publicRequest";
import eye from "assets/svg/eye.svg"
import eyeSlash from "assets/svg/eye-slash.svg"
import { getStock } from "redux/stockSlice";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import NewPassword from "../newpassword/NewPassword";
import { privateRequestDotNet } from "services/privateRequest";

const initialValues = {
  username: "",
  password: ""
}

const initialTouched = {
  username: false,
  password: false
}

const Login = () => {
  const dispatch = useDispatch()
  const [isCode, setIsCode] = useState(false);
  const location = useLocation()
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [values, setValues] = useState(initialValues);
  const [errors, setErrors] = useState(initialValues);
  const [touched, setTouched] = useState(initialTouched);
  const navigate = useNavigate();
  const code = location?.search?.split("token=")[1];
  const text = "Welcome Login Here";
  const [displayText, setDisplayText] = useState('');
  const [charIndex, setCharIndex] = useState(0);

  const handleChange = (e, name) => {
    setValues({
      ...values,
      [name]: e.target.value
    });

    setErrors({
      ...errors,
      [name]: !e.target.value ? "This field is required" : name === "username" && !emailRegex.test(e.target.value) ? "Invalid email format" : ""
    })
  };

  const handleBlur = (e, name) => {
    setTouched({
      ...touched,
      [name]: true,
    });
    setErrors({
      ...errors,
      [name]: !e.target.value ? "This field is required" : name === "username" && !emailRegex.test(e.target.value) ? "Invalid email format" : ""
    })
  };
  const login = async (e) => {
    e.preventDefault()
    if (location?.pathname == "/forgotpassword") {
      if (!values.username || !emailRegex.test(values.username)) {
        setErrors({
          username: !values.username ? "This field is required" : !emailRegex.test(values.username) ? "Invalid email format" : "",

        })
        setTouched({
          username: true,
        })
        return
      }
    } else {
      if (!values.username || !values.password) {
        setErrors({
          username: !values.username ? "This field is required" : "",
          password: !values.password ? "This field is required" : ""
        })
        setTouched({
          username: true,
          password: true
        })
        return
      }
      if (Object.values(errors).join("").length) {
        return
      }
    }
    if (location?.pathname == "/forgotpassword") {
      setIsSubmitting(true);
      try {
        let res = await publicRequest.post(FORGOT_PASSWORD, { email: values?.username })
        toast.success("Submitted Successfully")
        navigate("/login")
      } catch (err) {
        toast.error("invalid")
      }
      setIsSubmitting(false);

    } else {

      setIsSubmitting(true);
      try {
        const res = await privateRequestDotNet.post(LOGIN_NEW, values)
        localStorage.setItem("token", res?.data?.token)
        localStorage.setItem("username", values?.username)
        localStorage.setItem("refreshToken", res?.data?.refresh)
        localStorage.setItem("permission", JSON.stringify(res?.data?.reportType))
        toast.success("Login Successful")
        navigate("/")
      } catch (error) {
        toast.error("Invalid Email or Password")
      }
    }

    setIsSubmitting(false);
  };

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };
  useEffect(() => {
    const timer = setTimeout(() => {
      if (charIndex < text.length) {
        setDisplayText(displayText + text.charAt(charIndex));
        setCharIndex(charIndex + 1);
      } else {
        setDisplayText('');
        setCharIndex(0);
      }
    }, 150);


    return () => {
      clearTimeout(timer);
    };
  }, [charIndex, text, displayText]);
  useEffect(() => {
    if (location?.pathname == "/forgotpassword") {
      setValues({
        ...values,
        username: ""
      })
    }
  }, [location?.pathname])
  useEffect(() => {
    if (code) {
      setIsCode(true);
    } else {
      setIsCode(false)
    }
  }, [location?.pathname, code]);
  return (
    <>
      {
        isCode ? <NewPassword code={code} /> : <div className={classes.mainContainer}>
          <div className={classes.effectDiv}>
            {/* <p className={classes.textInfo}>{displayText}</p> */}
          </div>

          <div className={classes.imageDiv}>
            <div className={classes.innerEffectDiv}>
            </div>
          </div>
          <div className={classes.shapeDiv}>
          </div>
          <form onSubmit={login} className={classes.loginForm}>
            <div className={classes.loginDiv}>
              {
                location?.pathname == "/forgotpassword" ? <p className={classes.loginHeading2}> Forgot Password?<br /> <span style={{ fontSize: "16px" }}> Enter your registered Email Id</span></p> : <p className={classes.loginHeading}>Welcome To FFCorp Stock<br /> Automation</p>
              }


              {/* <p className={classes.loginHeading}>Welcome Login Here</p> */}

              <div className={classes.inputField}>
                <label htmlFor="email">Email <span className="required-mark">*</span></label>
                <input
                  name="username"
                  autoComplete="off"
                  value={values.username}
                  placeholder="Email"
                  onChange={(e) => handleChange(e, "username")}
                  onBlur={(e) => handleBlur(e, "username")}
                />
                {errors.username && touched.username ? (
                  <p className={classes.validationErrorText}>{errors.username}</p>
                ) : (
                  ""
                )}
              </div>
              {
                location.pathname == "/forgotpassword" ? null : <div className={classes.inputField}>
                  <label htmlFor="password">Password <span className="required-mark">*</span></label>
                  <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    placeholder="Password"
                    autoComplete="off"
                    value={values.password}
                    onChange={(e) => handleChange(e, "password")}
                    onBlur={(e) => handleBlur(e, "password")}
                  />
                  <div className={classes.eyeIcon} onClick={toggleShowPassword}>
                    {showPassword ?
                      <img src={eyeSlash} alt="show password" />
                      :
                      <img src={eye} alt="show password" />
                    }
                  </div>
                  {errors.password && touched.password ? (
                    <p className={classes.validationErrorText}>{errors.password}</p>
                  ) : (
                    ""
                  )}
                </div>
              }
              {
                location?.pathname == "/forgotpassword" ?
                  <>
                    <button
                      className={classes.loginButton}
                      type="submit"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? <span>Submitting <i className="fa fa-refresh fa-spin mx-2"></i></span> : "Submit"}
                    </button> <Link to="/login" style={{ textDecoration: "none", marginTop: "10px", fontWeight: "600", fontSize: "15px" }} onClick={() => {
                      setErrors({
                        ...errors,
                        username: ""
                      })
                    }}>Back to Login</Link></>
                  :
                  <>
                    <button
                      className={classes.loginButton}
                      type="submit"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? <span>Logging in <i className="fa fa-refresh fa-spin mx-2"></i></span> : "Login"}
                    </button>
                    {/* <Link to="/forgotpassword" style={{ textDecoration: "none", marginTop: "10px", fontWeight: "600", fontSize: "15px" }} onClick={() => {
                      setErrors({
                        ...errors,
                        username: ""
                      })
                    }}>Forgot Password ?</Link> */}
                  </>

              }
            </div>
          </form>

        </div>
      }
    </>

    // <NewPassword />


  );
};

export default Login;